import * as types from "@/store/mutationTypes";

export const mutations = {
    [types.SET_ACTIVITIES_INFO](state, activitiesInfo) {
        state.activitiesInfo = activitiesInfo;
    },

    [types.SET_ACTIVITIES_CLASSES](state, classes) {
        state.classes = classes;
    },

    [types.SET_ACTIVITIES_CAMPS](state, camps) {
        state.camps = camps;
    },

    [types.SET_ACTIVITY_CAMP_PRICING](state, campPricing) {
        state.campPricing = campPricing;
    },

    [types.SET_ACTIVITIES_AFTERCARE_SESSIONS](state, sessions) {
        state.aftercareSessions = sessions;
    },

    [types.SET_ACTIVITY_AFTERCARE_DAY](state, day) {
        state.aftercareDay = day;
    },

    [types.SET_ACTIVITY](state, activity) {
        state.activity = activity;
    },

    [types.SET_ACTIVITIES_CLASS_REQUIRED](state, activitiesClassRequired) {
        state.activitiesClassRequired = activitiesClassRequired;
    },

    [types.SET_ACTIVITIES_CAMP_REQUIRED](state, activitiesCampRequired) {
        state.activitiesCampRequired = activitiesCampRequired;
    },

    [types.SET_ACTIVITIES_AFTERCARE_REQUIRED](state, activitiesAftercareRequired) {
        state.activitiesAftercareRequired = activitiesAftercareRequired;
    },

    [types.SET_TEACHERS](state, teachers) {
        state.teachers = teachers;
    },

    [types.SET_PICK_UP](state, pickUps) {
        state.pickUps = pickUps;
    },

    [types.SET_T_SHIRT_SIZES](state, tShirtSizes) {
        state.tShirtSizes = tShirtSizes;
    },

    [types.SET_ACTIVITY_EXTRAS](state, activityExtras) {
        state.activityExtras = activityExtras;
    },

    [types.SET_ACTIVITY_EXTRAS_CAMP](state, activityExtrasCamp) {
        state.activityExtrasCamp = activityExtrasCamp;
    },

    [types.SET_ACTIVITY_EXTRAS_AFTERCARE](state, activityExtrasAftercare) {
        state.activityExtrasAftercare = activityExtrasAftercare;
    },

    [types.SET_ACTIVITY_EXTRAS_AFTERCARE_WHICH_USES_BEFORE](state, activityExtrasAftercareWhichUsesBefore) {
        state.activityExtrasAftercareWhichUsesBefore = activityExtrasAftercareWhichUsesBefore;
    },

    [types.SET_ACTIVITY_CHILD_ROSTER_INFO](state, childInfo) {
        state.childRosterInfo = childInfo;
    },

    [types.SET_POLICIES](state, policies) {
        state.policies = policies || [];
    },

    [types.SET_ACTIVITIES_AFTERCARE_DROP_IN_FULL](state, fullDropInDates) {
        state.activitiesAftercareDropInFull = fullDropInDates;
    },

    [types.SET_ACTIVITIES_AFTERCARE_ROSTERS_FREE_DAYS](state, freeDays) {
        state.activitiesAftercareRostersFreeDays = freeDays;
    },

    [types.SET_ACTIVITIES_AFTERCARE_WAITLIST_FREE_DAYS](state, freeDays) {
        state.activitiesAftercareWaitlistFreeDays = freeDays;
    },

    [types.UPDATE_CUSTOM_FORM](state, ids) {
        const res = state.activity.forms.filter(form => ids.includes(form.id));
        state.activityForms = res;
    },

    [types.CLEAN_ACTIVITY_FORMS](state) {
        state.activityForms = [];
    },

    
};


// WEBPACK FOOTER //
// ./src/store/modules/activities/mutations.js